module.exports = __webpack_public_path__ + "static/search-empty-state-a88972e68aae805cb34ee1b8d18f3d93.svg";